var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col h-screen max-h-screen bg-gray-100 overflow-auto"},[_c('router-view'),_c('notification-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }